<template>
  <div class="content-item">
    <h2 class="heading">Add your Church Address to be Seen on the Church Finder</h2>
    <p class="text">
      Congrats on completing the first step! Now it is time to create your church address. Watch the video in this section and follow the steps. Then return back to the dashboard by clicking the top
      menu selection on the far left that says, “Dashboard.”
    </p>
    <div class="radio-group">
      <div class="row">
        <p class="text"><a class="link-button" href=" https://mytruelife.org/campuses" target="_blank"> Click Here</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  name: 'Step2',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
  },
  computed: {
    backCards() {
      return get(this.source, 'back', []);
    },
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
    doSelectCard(card) {
      this.$emit('onSelectCard', card);
    },
    doSetCardSelected(card) {
      this.selected = card;
      setTimeout(() => {
        this.$emit('onNextPage');
      }, 500);
    },
    submit() {
      this.$emit('input', {
        ...this.value,
        card_back: this.selected.id,
      });
    },
  },
};
</script>
